<template>
  <transition name="fade">
    <div class="popup-mask" @click="close" @mousewheel.prevent v-if="visible">
      <div class="popup-wrapper" @click.stop>
        <div class="close-btn" @click="close"><i class="el-icon-close"></i></div>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="less" scoped>
/* .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
} */
.fade-enter, .fade-leave-to {
  opacity: 0;
  .popup-wrapper {
    transform: translateY(-20px);
  }
}

.popup-mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity .3s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .popup-wrapper {
    transition: transform .3s;
    position: relative;
    .close-btn {
      width: 24px;
      height: 24px;
      font-size: 22px;
      color: #666;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 24px;
      top: 24px;
      cursor: pointer;
      transition: color .15s linear;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
</style>
